module.exports = __webpack_public_path__ + "img/version-control.5083e9ba.png";